<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="changeLanguage(localeObj.locale)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from "bootstrap-vue";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find((l) => l.locale === this.$i18n.locale);
    },
  },
  methods: {
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: "en",
        img: "https://imagesassets.s3.ap-southeast-1.amazonaws.com/flag/en.png",
        name: "English",
      },
      {
        locale: "km",
        img: "https://imagesassets.s3.ap-southeast-1.amazonaws.com/flag/km.png",
        name: "ខ្មែរ",
      },
      {
        locale: "cn",
        img: "https://imagesassets.s3.ap-southeast-1.amazonaws.com/flag/cn.png",
        name: "中国人",
      },
      {
        locale: "th",
        img: "https://imagesassets.s3.ap-southeast-1.amazonaws.com/flag/th.png",
        name: "แบบไทย",
      },
      {
        locale: "vn",
        img: "https://imagesassets.s3.ap-southeast-1.amazonaws.com/flag/vn.png",
        name: "Tiếng Việt",
      },
      {
        locale: "lo",
        img: "https://imagesassets.s3.ap-southeast-1.amazonaws.com/flag/lo.png",
        name: "ພາສາລາວ",
      },
    ];
    /* eslint-disable global-require */

    return {
      locales,
    };
  },
};
</script>

<style>
</style>
